@let autoCompleteSuggestions = autoCompleteSuggestions$ | async;

<form
  #ngForm="ngForm"
  class="flex flex-col"
  [formGroup]="chipsForm"
  rmsCompositeForm
>
  <div
    class="flex flex-col sm:flex-row justify-between items-end gap-2 w-full mb-2"
    [ngClass]="{ 'justify-end': label, 'min-h-[34px]': displayInsertSelect }"
  >
    @if (label) {
      <label for="chip-input" class="w-full !mb-0">
        {{ label | translate }}
      </label>
    }
    @if (displayInsertSelect) {
      <mat-form-field
        subscriptSizing="dynamic"
        class="form-field-xs w-full sm:max-w-60"
        [matTooltip]="'libs.editor.tooltip.references' | translate"
        [matTooltipDisabled]="chipsForm.disabled"
        matTooltipPosition="above"
      >
        <mat-select
          [placeholder]="'libs.editor.actions.references' | translate"
          [disabled]="chipsForm.disabled"
          (selectionChange)="insertSelectSuggestion($event); input.value = ''"
        >
          @for (suggestion of suggestions; track suggestion.value) {
            @if (isVariable(suggestion.value)) {
              <mat-option [value]="suggestion.value">
                <span class="rms-badge rms-badge_sm success">
                  <span>V&nbsp;</span>{{ suggestion.label | translate }}
                </span>
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
  <mat-form-field class="w-full" subscriptSizing="dynamic">
    <mat-chip-grid
      #chipGrid
      [disabled]="chipsForm.disabled"
      class="max-w-[95%]"
    >
      @for (email of emails; track email.id) {
        <mat-chip-row
          (removed)="remove(email.id)"
          [class.variable-chip]="isVariable(email.value)"
        >
          @if (isVariable(email.value)) {
            <span class="w-full font-bold truncate">
              <span>V&nbsp;</span>{{ email.label | translate }}
            </span>
          } @else {
            <span class="w-full font-bold truncate">
              {{ email.label | translate }}
            </span>
          }

          <button matChipRemove>
            <mat-icon class="icon-xs" svgIcon="remix:System/close-large-fill" />
          </button>
        </mat-chip-row>
      }
      <input
        #input
        matInput
        id="chip-input"
        formControlName="input"
        [placeholder]="placeholder | translate"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        matChipInputAddOnBlur
        [matAutocomplete]="auto"
        (matChipInputTokenEnd)="add($event)"
      />

      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="insertAutocompleteSuggestion($event)"
      >
        @for (suggestion of autoCompleteSuggestions; track suggestion.value) {
          @if (isVariable(suggestion.value)) {
            <mat-option [value]="suggestion.value">
              <span class="rms-badge rms-badge_sm success">
                <span>V&nbsp;</span>{{ suggestion.label | translate }}
              </span>
            </mat-option>
          }
        }
      </mat-autocomplete>
    </mat-chip-grid>
  </mat-form-field>

  @let inputInvalid =
    (chipsForm.controls.input.touched && chipsForm.controls.input.invalid) ||
    (ngForm.submitted && chipsForm.controls.input.invalid);
  @let emailListInvalid = form.invalid;
  @let externalValidationInvalid =
    (chipsForm.controls.input.touched && !!externalValidationErrors) ||
    (ngForm.submitted && !!externalValidationErrors);
  @let shouldShowError =
    inputInvalid || emailListInvalid || externalValidationInvalid;

  <rms-control-error
    [label]="errorLabel | translate"
    [errors]="
      chipsForm.controls.input.errors || form.errors || externalValidationErrors
    "
    [errorState]="shouldShowError"
  />

  @if (!shouldShowError && note) {
    <mat-hint align="start">
      {{ note | translate }}
      @if (maxAttendees && maxAttendees > 0) {
        &nbsp;{{
          "libs.email-chips-input.hint"
            | translate: { max_attendees: maxAttendees }
        }}
      }
    </mat-hint>
  }
</form>
